import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  S3Client,
  AbortMultipartUploadCommand,

  UploadPartCommand,
  ListPartsCommand,

  UploadPartCommandOutput,
  CreateMultipartUploadCommand,
  CreateMultipartUploadCommandInput,
  CompleteMultipartUploadCommand,


} from "@aws-sdk/client-s3";

import { Store } from '@ngrx/store';
import { WSSState } from '../wss/wss.model';
import { customerId } from '../wss/wss.selectors';

@Injectable({
  providedIn: 'root'
})
export class MS3Service {


  recordedChunks: any = [];
  bRecording: boolean = false;


  credentials: any;
  client: S3Client | undefined
  call_id: string | undefined
  customer_id: string | undefined

  constructor(
    private httpClient: HttpClient,
    public wssState: Store<WSSState>,

  ) {
    console.log("MP# s3 service")

    this.wssState.select(customerId).subscribe((customer_id: string | undefined) => {
      this.customer_id = customer_id
    })
  }


  //****************************************************************************
  // One Multipart
  //****************************************************************************
  //****************************************************************************
  // Multipart Public API
  //****************************************************************************
  async startMultipart(user_id: string, call_id: string, rec_number: number, roll: string) {
    return new Promise<any>(async (resolve, reject) => {
      if (!this.client) {
        console.error("!this.client")
        return
      }
      try {
        //  this.credentials = await this.getMultipart() //Gets temporary security credentials
        let now = new Date().getTime() + 60 * 60 * 4 * 1000
        let signedUrlExpireSeconds = new Date(now)

        let s3_key = user_id + "/" + call_id + "/" + rec_number + "/" + roll + ".webm"

        let params: CreateMultipartUploadCommandInput = {
          Bucket: "k-recorder",
          Key: s3_key,
          Expires: signedUrlExpireSeconds,
          ContentType: 'video/webm'
        }
        let mpCmd = new CreateMultipartUploadCommand(params)
        const mpRes = await this.client.send(mpCmd);
        // process data.


        let uploadId = mpRes.UploadId
        console.log("MP# ok UploadId " + uploadId)

        resolve({ s3_key: s3_key, uploadId: uploadId })
      } catch (e) {
        reject(e)
      }
    })
  }
  async uploadMultipart(blob: Blob, context: any) {
    return new Promise<void>(async (resolve, reject) => {
      if (!this.client) {
        console.error("!this.client 2")
        return
      }
      try {

        let uploadParams = {
          Body: blob,
          Bucket: this.credentials.Bucket,
          Key: context.s3_key,
          PartNumber: context.partNumber,
          UploadId: context.uploadId,
          ContentLength: blob.size
        }
        let uploadCmd = new UploadPartCommand(uploadParams)
        const uploadRes: UploadPartCommandOutput = await this.client.send(uploadCmd);
        console.log("MP# uploaded multipart " + context.partNumber)
        context.partNumber++;
        resolve()
      } catch (error) {
        console.error("MP# error mp " + error)
        reject(error)
      }
    })
  }
  async completeMultiPart(contex: any) {
    return new Promise<void>(async (resolve, reject) => {
      if (!this.client) {
        console.error("!this.client 3")
        return
      }
      try {
        let parts = await this.getParts(contex)
        let mp: any = {}
        if (parts) {
          mp.Parts = parts
        } else {
          console.log("No Parts")
          mp.Parts = []
        }

        let completeCmdParams: any = {
          Bucket: this.credentials.Bucket,
          Key: contex.s3_key,
          UploadId: contex.uploadId,
          MultipartUpload: mp
        }
        let completeCmd = new CompleteMultipartUploadCommand(completeCmdParams)
        await this.client.send(completeCmd);
        console.log("MP# complete ok ")
        resolve()
        return

      } catch (error) {
        console.error("MP# complete mp error " + error)
        reject(error)
      }
    })
  }
  async abortMultiPart(context: any) {
    return new Promise<void>(async (resolve, reject) => {
      if (!this.client) {
        console.error("!this.client 4")
        return
      }
      let abortCmdParams = {
        Bucket: this.credentials.Bucket,
        Key: context.s3_key,
        UploadId: context.uploadId,
      }
      let abortCmd = new AbortMultipartUploadCommand(abortCmdParams)
      try {
        const abortRes = await this.client.send(abortCmd);
        // process data.
        console.log("MP# abort ok ")
        resolve()
        return
      } catch (error) {
        reject(error)
      }
    })
  }

  //****************************************************************************
  //Public utils
  //****************************************************************************

  async createS3Client() {
    return new Promise<any>(async (resolve, reject) => {
      if (this.client) {
        resolve(this.client)
        return;
      }
      try {
        this.credentials = await this.httpClient.get('/s3-tmp-creds/').toPromise();
        let credentials: any = {
          secretAccessKey: this.credentials.secretAccessKey,
          accessKeyId: this.credentials.accessKeyId,
        }
        this.client = new S3Client(
          {
            region: "us-west-1",
            credentials: credentials
          });
        resolve(this.client);
      } catch (e) {
        reject(e)
      }
    })
  }
  async uploadFile(file: File, id: string): Promise<void> {
    return new Promise<void>(async (resolve, reject) => {

      if (file) {
        try {
          let key = this.customer_id + "/" + id

          // Step 1: Get a signed URL from the backend
          let signedUrl: any = await this.getPostLink(key, file.type)

          // Step 2: Upload file directly to S3 using PUT request
          await this.httpClient.put(signedUrl, file, {
            headers: { 'Content-Type': file.type }
          }).toPromise();
          resolve()
        } catch (e) {
          reject(e)
        }
      }
    })
  }

  async uploadVideo(file: Blob, id: string): Promise<void> {
    return new Promise<any>(async (resolve, reject) => {
      console.log("upload video to s3 " + id)
      if (!this.customer_id) {
        reject("!this.customer_id")
        return
      }
      let key = this.customer_id + "/" + id
      let uploadUrl = await this.getPostLink(key, file.type)
      try {
        // await this.httpClient.put(uploadUrl, file, { headers: { 'Content-Type': "video/webm" } }).toPromise();
        //The header is added by the app.interceptor
        await this.httpClient.put(uploadUrl, file).toPromise();
        resolve(uploadUrl);
      } catch (error) {
        reject('Error uploading blob:' + JSON.stringify(error));
      }
    })
  }
  async uploadBlob(file: Blob, id: string): Promise<void> {
    return new Promise<any>(async (resolve, reject) => {
      console.log("upload blob to s3")
      let key = this.customer_id + "/" + id + ".blob"
      let uploadUrl = await this.getPostLink(key, file.type)

      try {
        // await this.httpClient.put(uploadUrl, file, { headers: { 'Content-Type': "video/webm" } }).toPromise();
        //The header is added by the app.interceptor
        await this.httpClient.put(uploadUrl, file).toPromise();
        resolve(uploadUrl);
      } catch (error) {
        reject('Error uploading blob:' + error);
      }
    })
  }
  async getBlob(id: string): Promise<Blob> {
    return new Promise<any>(async (resolve, reject) => {
      console.log("get s3 blob for" + id)
      let key = this.customer_id + "/" + id + ".blob"
      try {
        let rv: any = await this.httpClient.put<any>('/rec_link', { key: key, type: "application/octet-stream" }).toPromise();
        let url = rv.url
        let blob = await this.httpClient.get(url, { responseType: 'blob' }).toPromise();
        resolve(blob);
      } catch (error) {
        reject('Error getting blob:' + error);
      }

    })
  }
  async getPostLink(key: string, type: string) {
    return new Promise<string>(async (resolve, reject) => {
      try {

        if (key) {
          let url = '/post_rec' //rep
          // let url = '/post_rec_b'  //Caller

          let rv: any = await this.httpClient.put<any>(url, { key: key, type: type }).toPromise();
          resolve(rv.url)
        } else {
          reject("no key")
        }
      } catch (e: any) {
        console.error("Error update user " + JSON.stringify(e))
        reject(e)
      }
    })
  }
  /*
    private async getMultipart() {
      return new Promise<any>(async (resolve, reject) => {
        try {
          let url = '/k-multi/' + this.call_id
          let rv: any = await this.httpClient.get(url).toPromise();
          resolve(rv);
        } catch (e) {
          reject(e)
        }
      })
    }*/
  async getParts(contex: any) {
    return new Promise<any[]>(async (resolve, reject) => {
      if (!this.client) {
        console.error("!this.client 5")
        return
      }
      let parts: any[]
      let listParams = {
        Bucket: this.credentials.Bucket,
        Key: contex.s3_key,
        UploadId: contex.uploadId,
      }
      let listCmd = new ListPartsCommand(listParams)

      try {
        const listRes: any = await this.client.send(listCmd);
        // process data.
        if (listRes.Parts) {
          console.log("MP# get parts ok " + JSON.stringify(listParams))
        }
        else {
          console.log("MP# get parts = NO PARTS " + JSON.stringify(listParams))
        }
        resolve(listRes.Parts)
      } catch (error) {
        console.error("MP# get parts error " + error)
        reject(error)
      }
    })
  }




  //****************************************************************************
  // One Blob
  //****************************************************************************
  async getRecToS3URL(id: string, mime_type: string): Promise<string> {
    return new Promise<any>(async (resolve, reject) => {
      console.log("upload video to s3 " + id)
      if (!this.customer_id) {
        reject("!this.customer_id")
        return
      }
      let key = this.customer_id + "/" + id
      try {
        let uploadUrl = await this.getPostLink(key, mime_type)
        resolve(uploadUrl);
      } catch (e) {
        reject(e)
      }
    })
  }

  //If I have a break point it works no idea why, it works with the setTimeout
  async uploadChunk(presignedUrl: any, blob: Blob, type: string) {
    return new Promise<void>((resolve, reject) => {
      setTimeout(async () => {
        try {
          await fetch(presignedUrl, {
            method: 'PUT',
            body: blob,
            headers: { 'Content-Type': type }//'video/webm' }
          });
          resolve()
          // console.log('Chunk uploaded');
        } catch (e) {
          reject(e)
        }
      })
    })
  }
  async getRecURL() {
    return new Promise<any>(async (resolve, reject) => {

      try {
        let url = '/k-record/' + this.call_id
        let rv: any = await this.httpClient.get(url).toPromise();
        resolve(rv);
      } catch (e) {
        reject(e)
      }
    })
  }
  async uploadArray(blob: Blob) {
    return new Promise<void>(async (resolve, reject) => {
      try {
        let rec_url = await this.getRecURL()
        let array = await blob.arrayBuffer()
        // let stream = blob.stream()
        // let file = new File([blob], "abc.webm")
        // try {
        let rv: any = await this.httpClient.put(rec_url, array).toPromise();
        resolve(rv)
      } catch (e) {
        reject(e)
      }
    })
  }
  deleteFile(key: string) {
    return new Promise<void>(async (resolve, reject) => {
      try {

        if (this.customer_id) {
          let remove_key = this.customer_id + "/" + key
          let rv = await this.httpClient.put('/s3_remove', { keys: [remove_key], bucket: "k-recorder" }).toPromise();
        }
        resolve()
      } catch (e) {
        reject(e)

      }
    })
  }
}
